import i18n from ".";
import { en } from "../locales/en";

export type VocabularyList = keyof typeof en.vocabulary;

const entryOf = (list: VocabularyList, stored: string) => {
  const wanted = stored.trim().toLowerCase();
  return Object.entries(en.vocabulary[list]).find(([, english]) => english.toLowerCase() === wanted);
};

// Note: translated only while the stored name is still the product's English; a name the mine changed shows as stored.
export function vocabularyName(list: VocabularyList, stored: string): string;
export function vocabularyName(list: VocabularyList, stored: string | null | undefined): string | null | undefined;
export function vocabularyName(list: VocabularyList, stored: string | null | undefined) {
  if (!stored) return stored;
  const entry = entryOf(list, stored);
  if (!entry) return stored;

  const translated = i18n.t(`${list}.${entry[0]}`, { ns: "vocabulary", defaultValue: stored });
  return translated === entry[1] ? stored : translated;
}

export const machineStatusName = (status: string) =>
  status === "UP" ? i18n.t("list.up", { ns: "stoppages" }) : vocabularyName("stoppageTypes", status);

export const machineStatusDescription = (status: string, description: string | null | undefined) =>
  description?.startsWith(status) ? `${machineStatusName(status)}${description.slice(status.length)}` : description;
